<template>
  <v-app>
    <v-main>
      <app-error-messages />
      <div class="position-absolute mt-5 mr-2 right-0">
        <v-btn
          v-if="isDev && !!$auth.user"
          :to="$routeTo(ROUTES.LOGIN)"
          text="Logout"
          variant="text"
          @click.prevent="logout"
        />
      </div>
      <v-slide-x-reverse-transition mode="out-in">
        <span class="transition-wrapper">
          <slot />
        </span>
      </v-slide-x-reverse-transition>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import {defineComponent} from "vue"
import AppErrorMessages from "@/components/AppErrorMessages.vue"

export default defineComponent({
  components: {AppErrorMessages},
  data() {
    return {
      isDev: import.meta.env.VITE_APP_ENV === "dev" || import.meta.env.VITE_APP_ENV === "local",
    }
  },
  methods: {
    async logout() {
      await this.$auth.logout()

      await this.$router.push(this.$routeTo(this.ROUTES.LOGIN))
    }
  }
})
</script>

<style scoped></style>
